module.exports = __webpack_public_path__ + "static/media/banner1.138f61e0.png";